export default {
  title: 'Articles',
  subtitle: 'News, guides and updates from the PixelKey terminal.',
  loadFailed: "Couldn't load articles. Please try again.",
  emptyTitle: 'No articles here',
  emptyBody: 'No articles match this filter yet. Try another category.',
  more: 'More articles',
  published: 'Published',
  featured: 'Featured',
  readArticle: 'Read article',
  latest: 'Latest articles',
  readingMinutes: '{n} min read',
  read: 'Read',
  backToArticles: 'Back to articles',
  notFound: 'Article not found',
  shareThis: 'Share this article',
  copyLink: 'Copy link',
  linkCopied: 'Link copied',
};
